import { Store } from "../store";
import { EGiftDenomination } from "./EGiftDenomination.model";
import { EGiftTransaction } from "./EGiftTransaction.model";

export class EGiftVenue {
	venueKey: number;
	headerMessage: string;
	footerMessage: string;
	logoS3Key: string;
	menuItemKey: number;
	enabled: boolean;
	customAmount: boolean;
	balanceCheckUrl: string;
	emailRecipientGreetingText: string;
	emailCustomMessage: string;
	emailLogoS3Key: string;
	emailVenueUrl: string;
	emailVenueName: string;

	requireCardActivationByOriginalRecipientEmail: boolean;

	promoCodes: boolean;

	Venue: Store;
	EGiftDenomination: EGiftDenomination[];
	EGiftTransaction: EGiftTransaction[];

	public constructor(init?: Partial<EGiftVenue>) {
		Object.assign(this, init);
	}
}
